import styled from 'styled-components';
import Theme from 'utils/theme';

export const ExportModalShell = styled.div`
  display: flex;
  flex-direction: column;
  max-height: min(85vh, 820px);
  width: 100%;
  overflow: hidden;
  border-radius: 5px;
  background: #fff;
`;

export const ExportModalHeader = styled.div`
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #eaeaea;
  border-radius: 5px 5px 0 0;
  padding: 32px 48px 14px;
  text-align: center;
`;

export const ExportHeaderActions = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderIconButton = styled.button`
  appearance: none;
  border: none;
  background: rgba(255, 255, 255, 0.75);
  color: ${Theme.PrimaryDark};
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  transition: background 0.15s ease;

  &:hover {
    background: #fff;
  }

  &:focus {
    outline: 2px solid ${Theme.PrimaryColor};
    outline-offset: 1px;
  }
`;

export const ExportModalBody = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
`;

export const ExportModalFooter = styled.div`
  flex-shrink: 0;
  background: #fff;
`;

export const ExportFooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 16px 40px 10px 0;
`;

export const ExportFooterCancel = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 30px;
  background: ${(props) => props.bg || '#ececf0'};
  border-radius: 0 0 5px 5px;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 8px;
  background: #e6e6ef;
  overflow: hidden;
  border-radius: ${(props) => (props.rounded ? '999px' : '0')};
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${(props) => Math.max(0, Math.min(100, props.value || 0))}%;
  background: ${(props) =>
    props.error ? Theme.PrimaryRed : Theme.PrimaryColor};
  transition: width 0.35s ease;
`;

export const GeneratingProgressBar = styled.div`
  flex-shrink: 0;
  padding: 0 0 4px;
`;

export const GeneratingProgressMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px 6px;
  font-size: 13px;
  color: ${Theme.PrimaryGrey};
`;

export const MinimizedExportCard = styled.div`
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 10050;
  width: min(340px, calc(100vw - 32px));
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(61, 43, 86, 0.18);
  border: 1px solid ${Theme.PrimaryBorderColor};
  padding: 14px 14px 12px;
`;

export const MinimizedCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
`;

export const MinimizedCardTitle = styled.div`
  font-weight: 700;
  color: ${Theme.PrimaryDark};
  font-size: 14px;
  line-height: 1.3;
`;

export const MinimizedCardSubtitle = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: ${Theme.PrimaryGrey};
  line-height: 1.35;
`;
